import { render, staticRenderFns } from "./TalantRegistration.vue?vue&type=template&id=209f0bba&scoped=true&lang=pug&"
import script from "./TalantRegistration.vue?vue&type=script&lang=js&"
export * from "./TalantRegistration.vue?vue&type=script&lang=js&"
import style0 from "./TalantRegistration.vue?vue&type=style&index=0&id=209f0bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f0bba",
  null
  
)

export default component.exports